var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgR3WrongTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99902 60C9.99902 66.5661 11.2923 73.0679 13.805 79.1342C16.3178 85.2004 20.0008 90.7124 24.6437 95.3553C29.2866 99.9983 34.7986 103.681 40.8648 106.194C46.9311 108.707 53.4329 110 59.999 110C66.5651 110 73.0669 108.707 79.1332 106.194C85.1995 103.681 90.7114 99.9983 95.3544 95.3553C99.9973 90.7124 103.68 85.2004 106.193 79.1342C108.706 73.0679 109.999 66.5661 109.999 60C109.999 53.4339 108.706 46.9321 106.193 40.8658C103.68 34.7995 99.9973 29.2876 95.3544 24.6447C90.7114 20.0017 85.1995 16.3188 79.1332 13.806C73.0669 11.2933 66.5651 10 59.999 10C53.4329 10 46.9311 11.2933 40.8648 13.806C34.7986 16.3188 29.2866 20.0017 24.6437 24.6447C20.0008 29.2876 16.3178 34.7995 13.805 40.8658C11.2923 46.9321 9.99902 53.4339 9.99902 60Z",
    fill: "#FF7F36",
    stroke: "white",
    strokeWidth: 8.57,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.999 45L44.999 75",
    stroke: "white",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.999 45L74.999 75",
    stroke: "white",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR3WrongTick);
export default __webpack_public_path__ + "static/media/r3WrongTick.5e23e6ad437176a50d78cdf919af2e40.svg";
export { ForwardRef as ReactComponent };